export const PROVISIONAL_BILLING_MY_RECORDS_REQUEST = 'PROVISIONAL_BILLING_MY_RECORDS_REQUEST';
export const PROVISIONAL_BILLING_MY_RECORDS_SUCCESS = 'PROVISIONAL_BILLING_MY_RECORDS_SUCCESS';
export const PROVISIONAL_BILLING_MY_RECORDS_FAIL = 'PROVISIONAL_BILLING_MY_RECORDS_FAIL';

export const PROVISIONAL_BILLING_SUBMIT_REQUEST = 'PROVISIONAL_BILLING_SUBMIT_REQUEST';
export const PROVISIONAL_BILLING_SUBMIT_SUCCESS = 'PROVISIONAL_BILLING_SUBMIT_SUCCESS';
export const PROVISIONAL_BILLING_SUBMIT_FAIL = 'PROVISIONAL_BILLING_SUBMIT_FAIL';
export const PROVISIONAL_BILLING_SUBMIT_RESET = 'PROVISIONAL_BILLING_SUBMIT_RESET';

export const PROVISIONAL_BILLING_BULK_UPDATE_REQUEST = 'PROVISIONAL_BILLING_BULK_UPDATE_REQUEST';
export const PROVISIONAL_BILLING_BULK_UPDATE_SUCCESS = 'PROVISIONAL_BILLING_BULK_UPDATE_SUCCESS';
export const PROVISIONAL_BILLING_BULK_UPDATE_FAIL = 'PROVISIONAL_BILLING_BULK_UPDATE_FAIL';
export const PROVISIONAL_BILLING_BULK_UPDATE_RESET = 'PROVISIONAL_BILLING_BULK_UPDATE_RESET';

export const PROVISIONAL_BILLING_SUPERVISOR_BANKS_REQUEST = 'PROVISIONAL_BILLING_SUPERVISOR_BANKS_REQUEST';
export const PROVISIONAL_BILLING_SUPERVISOR_BANKS_SUCCESS = 'PROVISIONAL_BILLING_SUPERVISOR_BANKS_SUCCESS';
export const PROVISIONAL_BILLING_SUPERVISOR_BANKS_FAIL = 'PROVISIONAL_BILLING_SUPERVISOR_BANKS_FAIL';

export const PROVISIONAL_BILLING_ALL_RECORDS_REQUEST = 'PROVISIONAL_BILLING_ALL_RECORDS_REQUEST';
export const PROVISIONAL_BILLING_ALL_RECORDS_SUCCESS = 'PROVISIONAL_BILLING_ALL_RECORDS_SUCCESS';
export const PROVISIONAL_BILLING_ALL_RECORDS_FAIL = 'PROVISIONAL_BILLING_ALL_RECORDS_FAIL';
